export default __webpack_public_path__ + "static/media/listing-image.86004893.svg";